// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_pe-0";
export var buttonContainer = "_pe-3";
export var cancelButton = "_pe-4";
export var headerSection = "_pe-6";
export var headerTitle = "_pe-9";
export var messageSideLeft = "_pe-1";
export var messageSideRight = "_pe-2";
export var orderNumberContainer = "_pe-7";
export var orderNumberLabel = "_pe-8";
export var submitButton = "_pe-5";